import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { getCrisisCopy } from '../data/crisisResources';

const CrisisSupport = ({ language: languageProp }) => {
  const params = useParams();
  const language = languageProp || params.language || 'en';
  const copy = getCrisisCopy(language);

  return (
    <aside className="crisis-support" role="note">
      <strong>{copy.title}</strong>
      <p>{copy.body}</p>
      <ul>
        {copy.items.map((item) => (
          <li key={`${item.href}-${item.label}`}>
            <a href={item.href} rel="noopener noreferrer">
              {item.label}
            </a>
          </li>
        ))}
      </ul>
      <p>
        <Link to={`/${language}/clinical-safety`}>{copy.title}</Link>
      </p>
    </aside>
  );
};

export default CrisisSupport;
